import { IRequestWithSpecializationName } from 'legacy/lut/classes/models/onboarding/IRequest'

import { CodeType } from 'onboarding/classes/models/partnerFlag'

export interface IAgreement {
  id: string
  code: string
  codeType: CodeType | '-'
}

export enum EActionType {
  ChangePartnerId = 'change-partner-id',
  ConfirmPartnerId = 'confirm-partner-id',
  ChangeActiveContent = 'change-active-modal',
  GoToConfirm = 'go-to-confirm',
  SetExistingPendingRequestOfChosenPartner = 'set-existing-pending-request-of-chosen-partner',
  ShowPreloader = 'show-preloader',
  HidePreloader = 'hide-preloader',
  Reset = 'reset',
}

export enum EActiveContent {
  Select = 'select',
  Search = 'search',
  Confirm = 'confirm',
}

interface IState {
  showPreloader: boolean
  partnerId: string
  activeContent: EActiveContent
  agreementsToConfirm: IAgreement[]
  partnerIdToConfirm: string
  existingPendingRequestOfChosenPartner: IRequestWithSpecializationName | null
}

type TStateFields = keyof IState
type TActionPayload = Partial<IState> | Record<string, any>

interface IAction {
  type: EActionType
  payload?: TActionPayload
}

const getNonUndefinedPayloadValue = (state: IState, action: IAction, field: TStateFields) => {
  if (action.payload) {
    return action.payload[field] === undefined ? state[field] : action.payload[field]
  } else {
    return state[field]
  }
}

export const initialState: IState = {
  showPreloader: false,
  partnerId: '',
  activeContent: EActiveContent.Select,
  agreementsToConfirm: [],
  partnerIdToConfirm: '',
  existingPendingRequestOfChosenPartner: null,
}

export const reducer = (state: IState, action: IAction) => {
  const getFieldValue = (field: TStateFields) => getNonUndefinedPayloadValue(state, action, field)

  switch (action.type) {
    case EActionType.ShowPreloader:
      return { ...state, showPreloader: true }
    case EActionType.HidePreloader:
      return { ...state, showPreloader: false }
    case EActionType.ChangePartnerId:
      return {
        ...state,
        partnerId: getFieldValue('partnerId'),
        activeContent: EActiveContent.Select,
      }
    case EActionType.ChangeActiveContent:
      return {
        ...state,
        activeContent: getFieldValue('activeContent'),
      }
    case EActionType.GoToConfirm:
      return {
        ...state,
        activeContent: EActiveContent.Confirm,
        agreementsToConfirm: getFieldValue('agreementsToConfirm'),
        partnerIdToConfirm: getFieldValue('partnerIdToConfirm'),
      }
    case EActionType.ConfirmPartnerId:
      return {
        ...state,
        partnerId: getFieldValue('partnerId'),
        partnerIdToConfirm: '',
        agreementsToConfirm: [],
        activeContent: EActiveContent.Select,
      }
    case EActionType.SetExistingPendingRequestOfChosenPartner:
      return {
        ...state,
        existingPendingRequestOfChosenPartner: getFieldValue(
          'existingPendingRequestOfChosenPartner'
        ),
      }
    case EActionType.Reset:
      return { ...initialState }
    default:
      throw new Error(`There is no action with type = '${action.type}'`)
  }
}
